<template>
    <div class="h-full flex items-center">
        <div
            class="min-w-[9rem] min-h-[9rem] bg-cover bg-center base-responsive-rounding"
            :style="`background-image: url(${img})`"
        ></div>
        <div class="pl-6">
            <div class="font-Poppins font-bold text-xl sm:text-2xl">{{ title }}</div>
            <div class="mt-3 mb-4">
                {{ photoCount }} <span><T :tc="['media_library.photo', photoCount]" /></span>
            </div>
            <Button
                :to="localePath({ name: 'press-media-library-gallerycategory', params: { gallerycategory: slug } })"
                :label="$t('generic.read_more')"
                class="p-button-sm"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'MediaLibraryCard',
    props: {
        slug: {
            type: String,
            required: true,
        },
        img: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        photoCount: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style scoped></style>
